import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { H2, StringSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './style.module.scss';

import badgeLines from '/img/airdrop/badge_lines.png';
import masterIndustryPng from '/img/leaderBoard/masterIndustry.png';
import masterIndustryWebp from '/img/leaderBoard/masterIndustry.webp';

const BannerIndustry: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={cn('relative')}>
      <div className="absolute right-0 bottom-0 h-full aspect-[308/267]">
        <Picture img={masterIndustryPng} webp={masterIndustryWebp} alt="" />
      </div>
      <div
        className={cn(
          css.bannerIndustry,
          'relative flex flex-col justify-between min-h-[6.25rem] overflow-hidden p-3 rounded-lg',
        )}
      >
        <H2>{t('Masters of Industry!')}</H2>
        <StringSmall className="font-light leading-[120%] tracking-[0] text-white opacity-60 max-w-[12.5rem]">
          {t('See who runs the economy and aim higher for rewards!')}
        </StringSmall>
        <div className="absolute top-0 z-[-1]">
          <img src={badgeLines} alt="onboarding" />
        </div>
      </div>
    </div>
  );
};

export default BannerIndustry;
